import RichTextFieldStrapi, {
  RichTextFieldStrapiProps,
} from '@/components/atoms/RichTextField/RichTextFieldStrapi';
import { Text } from '@/components/atoms/Text';
import { Tooltip } from '@/components/atoms/Tooltip/Tooltip';
import toolTipIconSrc from '~/icons/tooltip_icon.svg';
import { SvgIcon } from '@/components/SvgIcon';

export interface ProductCategoryTitlesProps {
  categoryTitle?: string;
  tooltipText?: RichTextFieldStrapiProps;
}

export function ProductCategoryTitles({
  categoryTitle,
  tooltipText,
}: ProductCategoryTitlesProps) {
  return (
    <div className='group'>
      <div className='group-hover:bg-brand-100 flex gap-1 rounded-s bg-gray-50 p-2'>
        <Text className='text-body-m-medium group-hover:bg-brand-100  group-hover:text-brand-900 text-gray-500'>
          {categoryTitle}
        </Text>
        <div className='relative'>
          {!!tooltipText && (
            <Tooltip
              flowDirection='bottom-center'
              text={
                <RichTextFieldStrapi
                  block={{
                    ...tooltipText,
                  }}
                />
              }
              classNames={{ text: 'max-w-52' }}
            >
              <SvgIcon src={toolTipIconSrc} className='group-hover:text-brand-900 h-5 w-5 text-gray-400' />
            </Tooltip>
          )}
        </div>
      </div>
    </div>
  );
}
